module.exports = __webpack_public_path__ + "img/AnnaOrvos.8c6006f.png";